import React from 'react';
import { connect } from 'react-redux';
import { find, isEqual, capitalize, uniqBy } from 'lodash';
import ReactTable from 'react-table';
import Box from '../../common/Box';
import ReactSelect from '../../common/ReactSelect';
import CSV from '../../../helpers/CSVExport';
import ConfirmClick from '../../common/ConfirmClick';
import { rollingMonthRevenueSettings } from './RollingMonthRevenue/Settings';
import { territoriesActions } from '../../../data/actions/territories';
import StackedBarChart from '../../widgets/charts/types/StackedBarChart';
import LineChart from '../../widgets/charts/types/LineChart';
import DoughnutChart from '../../widgets/charts/types/DoughnutChart';
import { formatTooltipLabelDoughnutWithPercentage, formatTooltipLabelWithCurrency } from '../../widgets/charts/Formatter';
import { territoriesBar, territoriesLine, territoriesPie } from '../../widgets/charts/ChartDefaults';

var downloadSvg = require('!svg-inline-loader!../../../../public/img/download.svg');
var barSvg = require('!svg-inline-loader!../../../../public/img/chart-bar.svg');
var lineSvg = require('!svg-inline-loader!../../../../public/img/line.svg');
var tableSvg = require('!svg-inline-loader!../../../../public/img/table.svg');
var pieSvg = require('!svg-inline-loader!../../../../public/img/pie.svg');

const colors = {
  "Physical": "#3466CB",
  "Digital": "#FF9900",
  "Neighboring Rights": "#159619"
};

class RollingMonthRevenue extends React.Component {
	
	nullElement = {value: null, label: 'All'}
	
	constructor(props) {
		super(props);
		this.state = {
			mode: 'table'
		}
		this.exportToCsv = this.exportToCsv.bind(this);
	}
	
	exportToCsv(){
		const { months } = this.props.territories;	
		const dateFilter = this.props.filter || {};
	const filename = CSV.CSVHeader('rolling_month_revenue', null, (dateFilter.dateStart && dateFilter.dateEnd) ? {dateStart: dateFilter.dateStart, dateEnd: dateFilter.dateEnd} : null);
		return CSV.CSVExport(months, {filename}, 'rolling_month_revenue');
	}
	
	renderToolbar(data){
		let toolbar = [];
		toolbar.push(<div key="wrapper" className="ibox-action-holder">
		<a key='table' title="Table" className={`chart-icon ${this.state.mode == 'table' ? 'active' : ''}`} 
			onClick={()=>this.setChartMode('table')}
			dangerouslySetInnerHTML={{__html: tableSvg}}>
		</a>
		<a key='line' title="Line Chart" className={`chart-icon ${this.state.mode == 'line' ? 'active' : ''}`} 
			onClick={()=>{this.setChartMode('line'); }}
			dangerouslySetInnerHTML={{__html: lineSvg}}>
		</a>
		<a key='bar' title="Bar Chart" className={`chart-icon ${this.state.mode == 'bar' ? 'active' : ''}`} 
			onClick={()=>{this.setChartMode('bar'); }}
			dangerouslySetInnerHTML={{__html: barSvg}}>
		</a>
		{/*
		<a key='pie' title="Pie Chart" className={`chart-icon ${this.state.mode == 'pie' ? 'active' : ''}`} 
			onClick={()=>{this.setChartMode('pie'); }}
			dangerouslySetInnerHTML={{__html: pieSvg}}>
		</a>
		*/}
		<div className="ibox-actions">
			<ConfirmClick confirmAction={this.exportToCsv} title="Export CSV" confirmClass="" confirmLabel={<span key="download" className="chart-icon download-link" dangerouslySetInnerHTML={{__html: downloadSvg}} />} confirmPrompt="These reports are for analytical purposes only and should not be used to pay artist royalties"></ConfirmClick>
			
		</div>
		</div>)

		return toolbar;
	}
			
	setChartMode(mode){
		this.setState({mode}, ()=>{
		});
	}

	componentDidMount() {
		this.props.getRollingMonthsRevenue(this.props.filter);
	}

	getTimeseries = (monthTimeseries) => {
		return {
			...monthTimeseries,
			datasets: monthTimeseries.datasets.map(ds => {
				const color = colors[ds.label];
				return {
					...ds,
					backgroundColor: color,
					borderColor: color,
					pointBackgroundColor: color,
					pointBorderColor: color,
				};
			})
		};
	};

	getPie = (pieData) => {
		return {
			...pieData, 
			datasets: pieData.datasets.map(ds => ({
				...ds,
				backgroundColor: pieData.labels.map(label => colors[label])
			})),
			// options: {
			// 	tooltips: {
			// 		callbacks: {
			// 			label: (context) => {
			// 				console.log('yetst')
			// 				const value = context.raw;
			// 				const percent = ((value / total) * 100).toFixed(1);
			// 				return `${percent}%`;
			// 			}
			// 		}
			// 	}
			// }
		};
	};

	
	render (){  
		const { continent } = this.props,
		{ monthsLoading, months, monthTimeseries, monthPie } = this.props.territories;
		const rowsCount = Array.isArray(months)?months.length:0;
		return <Box title={`Rolling 12 Months Revenue`} toolbar={this.renderToolbar()} spinnerEnabled={(monthsLoading)} className="ibox-container rolling-box">
		{rowsCount > 0 && <React.Fragment>
			{this.state.mode=='table' && <ReactTable 
				className="rolling-months-revenue"
				data={months} 
				columns={rollingMonthRevenueSettings.settingsForTable()}
				defaultPageSize={rowsCount}
				//sorted={[{id: 'total_income', desc: true}]}
				//pivotBy={['source', 'classification']}
				showPagination={false}        	
				getTrProps={rollingMonthRevenueSettings.settingsForRow}
			/>}
			{this.state.mode=='line' && <div className="chart-block">
				<LineChart data={this.getTimeseries(monthTimeseries)} 
				options={territoriesLine()} chartID="territories_report_rolling_12_months_chart" />                          
			</div>}
			{this.state.mode=='bar' && <div className="chart-block">
				<StackedBarChart data={this.getTimeseries(monthTimeseries)} isCustomWidth={true} 
				options={territoriesBar()} chartID="territories_report_rolling_12_months_chart" />                          
			</div>}
			{this.state.mode=='pie' && <div className="chart-block">
				<DoughnutChart data={this.getPie(monthPie)} options={territoriesPie}  chartID="territories_report_rolling_12_months_chart" />                          
			</div>}
		</React.Fragment>}
		</Box>;
	}
}

function mapStateToProps(state) {
	return {
		stats: state.stats,
	} 
}

function mapStateToProps(state) {
	return {
		territories: state.territories,
	} 
}

function mapDispatchToProps(dispatch, ownProps) {
	return {
		getRollingMonthsRevenue: (continent) => {;
			dispatch(territoriesActions.getRollingMonthsRevenue(continent, ownProps.dateStart, ownProps.dateEnd, ownProps.countries))
		},		
	} 
}


export default connect(mapStateToProps, mapDispatchToProps)(RollingMonthRevenue);